import colors from '@/theme/colors';
import {
  BodyMediumMidEmphasisStyles,
  BodySmallMidEmphasisStyles,
  BodyLargeMidEmphasisdStyles,
  BodySmallEmphasizedStyles,
  BodyMediumMidEmphasisUnderlineStyles,
} from '@/design-system/Typography/Typography.styles';
import { pxToRem } from '@/utils';

export const ButtonPrimaryStyles = {
  '&:hover': {
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24) !important',
  },
  '&:not([disabled]):not(.disabled):active': {
    boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12) !important',
  },
  '&:disabled, &[disabled], &.disabled': {
    opacity: 1,
    backgroundColor: '#e8e8e8 !important',
    color: `${colors.neutralAsh} !important`,
    fontWeight: 'normal',
  },
};

export const ButtonPrimaryMediumStyles = {
  ...ButtonPrimaryStyles,
  ...BodyMediumMidEmphasisStyles,
  height: pxToRem(44),
  padding: `${pxToRem(12)} ${pxToRem(24)} !important`,
  borderRadius: '8px !important',
};

export const ButtonPrimarySmallStyles = {
  ...ButtonPrimaryStyles,
  ...BodySmallMidEmphasisStyles,
  height: pxToRem(32),
  padding: `${pxToRem(8)} ${pxToRem(16)} !important`,
  borderRadius: '8px !important',
};

export const ButtonPrimaryLargeStyles = {
  ...ButtonPrimaryStyles,
  ...BodyLargeMidEmphasisdStyles,
  height: pxToRem(56),
  padding: `${pxToRem(16)} ${pxToRem(32)} !important`,
  borderRadius: '8px !important',
};

export const ButtonFlatSmallStyles = {
  ...BodySmallMidEmphasisStyles,
  height: pxToRem(32),
  padding: `${pxToRem(8)} ${pxToRem(12)} !important`,
  borderRadius: '8px !important',
};

export const ButtonFlatMediumStyles = {
  ...BodyMediumMidEmphasisStyles,
  height: pxToRem(48),
  padding: `${pxToRem(12)} ${pxToRem(16)} ${pxToRem(12)} ${pxToRem(8)} !important`,
  borderRadius: '8px !important',
};

export const ButtonFlatLargeStyles = {
  ...BodyLargeMidEmphasisdStyles,
  height: pxToRem(56),
  padding: `${pxToRem(16)} ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(16)} !important`,
  borderRadius: '8px !important',
};

export const ButtonFlatSmallEmphasizedStyles = {
  ...BodySmallEmphasizedStyles,
  height: pxToRem(32),
  padding: `${pxToRem(8)} ${pxToRem(12)} !important`,
  borderRadius: '8px !important',
};

export const ButtonFlatMediumEmphasizedStyles = {
  ...BodyMediumMidEmphasisUnderlineStyles,
  height: pxToRem(48),
  padding: `${pxToRem(12)} ${pxToRem(16)} ${pxToRem(12)} ${pxToRem(8)} !important`,
  borderRadius: '8px !important',
};
